import React, { useState } from 'react';
import './CookieNotice.css';

const KEY = 'cookie-notice-ok';
const read = () => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } };

const CookieNotice = () => {
  const [hidden, setHidden] = useState(read);
  if (hidden) return null;

  const accept = () => {
    try { localStorage.setItem(KEY, '1'); } catch { /* приватный режим */ }
    setHidden(true);
  };

  return (
    <div className="cookie-notice" role="dialog" aria-label="Использование cookie">
      <p>
        Сайт использует cookie и сервисы статистики (Яндекс.Метрика) для работы и улучшения сайта.
        Продолжая пользоваться сайтом, вы соглашаетесь с этим. Подробнее — в{' '}
        <a href="/privacy#cookies">Политике конфиденциальности</a>.
      </p>
      <button type="button" onClick={accept}>Понятно</button>
    </div>
  );
};

export default CookieNotice;
